<template>
  <pdl-dialog
    v-model:visible="kioskModeEnabledOnSite"
    :title="$t('digitalHub.functionNotAvailable')"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :show-close="false"
    :z-index="16000011"
    qaid="login-disabled-dialog"
  >
    <template #footer>
      <div class="buttons buttons--right">
        <pdl-button primary @click="redirectBack">
          {{ $t('text.okay') }}
        </pdl-button>
      </div>
    </template>
  </pdl-dialog>
</template>

<script>
import {PdlDialog} from '@pedal/pdl-dialog';
import {PdlButton} from '@pedal/pdl-button';
import {mapState} from 'vuex';

export default {
  components: {PdlDialog, PdlButton},

  computed: {
    ...mapState('backend', ['kioskModeEnabledOnSite']),
  },

  mounted() {
    if (this.kioskModeEnabledOnSite) {
      setTimeout(() => {
        this.redirectBack();
      }, 60000);
    }
  },

  methods: {
    redirectBack() {
      window.history.back();
    },
  },
};
</script>
